// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5p-2";
export var blackBorderOnHover = "_5p-7";
export var cell = "_5p-6";
export var cellContainer = "_5p-3";
export var checked = "_5p-8";
export var disabled = "_5p-5";
export var featuredIconCellContainer = "_5p-9";
export var featuredIconTextContainer = "_5p-b";
export var featuredIconWrapper = "_5p-a";
export var noBorder = "_5p-c";
export var orangeSelectedRow = "_ej-3";
export var overflowableText = "_5p-0";
export var overflowableTextContainer = "_5p-1";
export var row = "_5q-0";
export var rowCheckboxCell = "_5p-4";
export var selectableTable = "_ej-2";